import React, { useState } from 'react';

export default function RawJSON({ data }) {
  const [collapsed, setCollapsed] = useState(false);
  if (!data) return <div style={{ padding: 40, color: 'var(--muted)', fontSize: 12 }}>Select a dataset to view raw JSON.</div>;

  return (
    <div style={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 14 }}>
        <h2 style={{ fontFamily: 'Syne, sans-serif', fontSize: 14, fontWeight: 700, letterSpacing: '.05em' }}>Raw JSON</h2>
        <button className="btn btn-secondary" onClick={() => {
          navigator.clipboard.writeText(JSON.stringify(data, null, 2));
        }} style={{ fontSize: 10 }}>Copy</button>
        <button className="btn btn-secondary" onClick={() => setCollapsed(!collapsed)} style={{ fontSize: 10 }}>
          {collapsed ? 'Expand' : 'Collapse'}
        </button>
      </div>
      {!collapsed && (
        <pre style={{
          flex: 1, overflow: 'auto', background: 'var(--surface2)', border: '1px solid var(--border)',
          borderRadius: 10, padding: 20, fontSize: 11, lineHeight: 1.7, color: 'var(--text)',
          whiteSpace: 'pre-wrap', wordBreak: 'break-word',
        }}>
          {JSON.stringify(data, null, 2)}
        </pre>
      )}
    </div>
  );
}
